import { createBrowserRouter, redirect } from "react-router-dom";
import App from "../App";
import Login from "../views/components/Login/Login";
import Signup from "../views/components/Signup/Signup";
import CreateEditUser from "../views/components/UserManagement/CreateEditUser/CreateEditUser";
import Main from "../views/components/Main/Main";
// import Dashboard from "../views/components/Dashboard/Dashboard";
import ForgotPassword from "../views/components/ForgotPassword/ForgotPassword";
import { protectedRouteLoader } from "../views/core/ProtectedRouteLoader/ProtectedRouteLoader";
import CreatePassword from "../views/components/CreatePassword/CreatePassword";
import MyAccount from "../views/components/UserManagement/CreateEditUser/MyAccount";
import ChangePassword from "../views/components/UserManagement/ChangePassword/ChangePassword";
import UserList from "../views/components/UserManagement/UserList/UserList";
import EditUser from "../views/components/UserManagement/CreateEditUser/EditUser";
import PendingApprovals from "../views/components/UserManagement/UserList/PendingApprovals";
import PublishUnPublishList from "../views/components/PublishUnPublish/PublishUnPublishList";
import ConfigrationNewRoom from "../views/components/ConfigurationNewRoom/ConfigurationNewRoom";
import ConfigrationNewHotel from "../views/components/ConfigurationNewHotel/ConfigurationNewHotel";
import UserPrivileges from "../views/components/UserManagement/UserPrivileges/UserPrivileges/UserPrivileges";
import RolesAndPermission from "../views/components/UserManagement/RolesAndPermissions/RolesAndPermission/RolesAndPermission";
import RolesList from "../views/components/UserManagement/Roles/RolesList";
import CreateEditRole from "../views/components/UserManagement/Roles/CreateEditRole";
import ConfigurationManagementForm from "../views/components/ConfigurationManagementForm/ConfigurationManagementForm";
import PartnerConfiguration from "../views/components/PartnerConfiguration/PartnerConfiguration";
import RoomTypeConfiguration from "../views/components/MasterRoomTypeConfiguration/RoomTypeConfiguration";
import ConfigurationBackgroundImage from "../views/components/ConfigurationBackgroundImage/ConfigurationBackgroundImage";
import RailConfig from "../views/components/RailConfiguration/RailConfig";
import HotelServiceConfiguration from "../views/components/HotelServiceConfiguration/HotelServiceConfiguration";
// import BootcampConfiguration from "../views/components/BootcampConfiguration/BootcampConfiguration";
import ScreensaverConfiguration from "../views/components/ScreensaverConfiguration/ScreensaverConfiguration";
import HotelChannels from "../views/components/HotelChannels/HotelChannels";
import UtilityServiceConfiguration from "../views/components/UtilityServiceConfiguration/UtilityServiceConfiguration";
import GroupRooms from "../views/components/GroupRooms/GroupRooms";
import DefaultConfiguration from "../views/components/DefaultConfiguration/DefaultConfiguration";
import SatelliteChannelMapping from "../views/components/SatelliteChannelMapping/SatelliteChannelMapping";
import CityConfiguration from "../views/components/CityConfiguration/CityConfiguration";
import MasterAPKConfiguration from "../views/components/MasterAPKConfiguration/MasterAPKConfiguration";
import MasterApkProvider from "../views/components/MasterApkProvider/MasterApkProvider";
import FetchCdsnDetails from "../views/components/FetchCDSNDetails/FetchCdsnDetails";
import WelcomeScreenConfig from "../views/components/WelcomeScreenConfig/WelcomeScreenConfig";
import GuestMessage from "../views/components/GuestMessage/GuestMessage";
import FetchCDSNDetailsAdmin from "../views/components/FetchCDSNDetailsAdmin/FetchCDSNDetailsAdmin";
import APKInstallationDetails from "../views/components/APKInstallationDetails/APKInstallationDetails";
import SoftwareStackDetails from "../views/components/SoftwareStackDetails/SoftwareStackDetails";
import ReSyncChainId from "../views/components/ReSyncChainId/ReSyncChainId";
// import HmsDashboard from "../views/components/HmsDashboard/HmsDashboard";
import HelpManual from "../views/components/HelpManual/HelpManual";
import ActivityLogs from "../views/components/ActivityLogs/ActivityLogs";
import WhitelistDomain from "../views/components/WhitelistDomain/WhitelistDomain";
import APKVersionDahsboard from "../views/components/HmsDashboard/APKVersionDahsboard/APKVersionDahsboard";
import AutomodeDashboard from "../views/components/HmsDashboard/AutomodeDashboard/AutomodeDashboard";
import HotelsDashboard from "../views/components/HmsDashboard/HotelsDashboard/HotelsDashboard";
import HotelOnboardingWizard from "../views/components/HotelOnboardingWizard/HotelOnboardingWizard";
import AssetManagementDashboard from "../views/components/HmsDashboard/AssetManagementDashboard/AssetManagementDashboard";
// import ManualCDSNMapping from "../views/components/ManualCDSNMapping/ManualCDSNMapping";

export const routerPath = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    // loader: () => {
    //   const token = localStorage.getItem("jwt");
    //   return redirect(token ? "/hms/dashboard" : "/login");
    // },
    children: [
      {
        path: "login",
        element: <Login />,
        // loader: () => {
        //   const token = localStorage.getItem("jwt");
        //   return redirect(token ? "/hms/dashboard" : "/login");
        // },

      },
      {
        path: "signup",
        element: <Signup />,
      },
      {
        path: "forgotPassword",
        element: <ForgotPassword />,
      },
      {
        path: "createPassword",
        element: <CreatePassword />,
      },
      {
        path: "hms",
        element: <Main />,
        loader: protectedRouteLoader,
        children: [
          {
            path: "HeroBanner",
            element: <ConfigurationManagementForm />,
          },
          {
            path: "HotelOnboardingWizard",
            element: <HotelOnboardingWizard />,
          },
          {
            path: "HotelChannels",
            element: <HotelChannels />,
          },
          {
            path: "WelcomeMessages",
            element: <PublishUnPublishList />,
          },
          {
            path: "GroupRooms",
            element: <GroupRooms />,
          },
          {
            path: "DefaultConfig",
            element: <DefaultConfiguration />,
          },
          {
            path: "ConfigurationNewRoom",
            element: <ConfigrationNewRoom />,
          },
          {
            path: "ConfigurationNewHotel",
            element: <ConfigrationNewHotel />,
          },
           {
            path: "Dashboard/Hotels_Dashboard",
            element: <HotelsDashboard />,
          },
          {
            path: "Dashboard/AssetManagement_Dashboard",
            element: <AssetManagementDashboard />,
          },
          {
            path: "Dashboard/APK_Version_Dahsboard",
            element: <APKVersionDahsboard />,
          },
          {
            path: "Dashboard/Automode_Dashboard",
            element: <AutomodeDashboard />,
          },
          {
            path: "activityLogs",
            element: <ActivityLogs />,
          },
          {
            path: "ConfigurationMasterApk",
            element: <MasterAPKConfiguration />,
          },
          {
            path: "ConfigurationBackgroundImage",
            element: <ConfigurationBackgroundImage />,
          },
             {
            path: "WelcomeScreenConfig",
            element: <WelcomeScreenConfig />,
          },
          {
            path: "PartnerConfiguration",
            element: <PartnerConfiguration />,
          },
           {
            path: "SoftwareStackDetails",
            element: <SoftwareStackDetails />,
          },
          {
            path: "RailConfiguration",
            element: <RailConfig />,
          },
          {
            path: "RoomTypeConfiguration",
            element: <RoomTypeConfiguration />,
          },
          {
            path: "HotelServiceConfiguration",
            element: <HotelServiceConfiguration />,
          },
          {
            path: "APKProviderConfiguration",
            element: <MasterApkProvider />,
          },
          {
            path: "ScreensaverConfiguration",
            element: <ScreensaverConfiguration />,
          },
          {
            path: "CityConfiguration",
            element: <CityConfiguration />,
          },
          {
            path: "helpManual",
            element: <HelpManual />,
          },
          {
            path: "WhitelistDomain",
            element: <WhitelistDomain />,
          },
          {
            path: "UtilityServiceConfiguration",
            element: <UtilityServiceConfiguration />,
          },
          {
            path: "SatelliteChannelMapping",
            element: <SatelliteChannelMapping />,
          },
          {
            path: "createEditUser",
            element: <CreateEditUser />
          },
          {
            path: "fetchcdsndetails",
            element: <FetchCdsnDetails />,
          },
          {
            path: "resyncchainid",
            element: <ReSyncChainId />,
          },
          {
            path: "fetchcdsndetailsAdmin",
            element: <FetchCDSNDetailsAdmin />,
          },
            {
            path: "APKInstallationDetails",
            element: <APKInstallationDetails />,
          },
          {
            path: "guestMessage",
            element: <GuestMessage />,
          },
          {
            path: "editUser",
            element: <EditUser />
          },
          {
            path: "myAccount",
            element: <MyAccount />
          },
          {
            path: "changePassword",
            element: <ChangePassword />
          },
          {
            path: "userList",
            element: <UserList />
          },
          {
            path: "pending-approvals",
            element: <PendingApprovals />
          },
          {
            path: "roles",
            element: <RolesList />
          },
          {
            path: "create-role",
            element: <CreateEditRole />
          },
          {
            path: "edit-role",
            element: <CreateEditRole />
          },
          {
            path: "userPrivilege",
            element: <UserPrivileges />
          },
          {
            path: "rolesPermissions",
            element: <RolesAndPermission />
          },
        ],
      },
    ],
  },
]);
